import { ConditionsDataContext } from "@builder/context/ConditionsData";
import { useContext } from "react";

export const useConditionData = () => useContext(ConditionsDataContext);
